import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { Modal } from "antd";
import { svg } from "../../../Assets/svg";
import { BtnLoader } from "../../../Components/Components";

const CommonDeleteModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleDelete: any;
  title: string;
  description: string;
  isLoading: boolean;
  setIsDeleteId?: React.Dispatch<React.SetStateAction<any>>;
  buttonName?: string;
  isLogo?: boolean;
  setAdditionalId?: React.Dispatch<React.SetStateAction<any>>;
  iconSvg?: JSX.Element;
  isSuccess?: boolean;
}> = ({
  visible,
  setIsModalVisible,
  handleDelete,
  title,
  description,
  setIsDeleteId,
  isLoading,
  buttonName,
  isLogo = true,
  setAdditionalId,
  iconSvg = svg?.deleteModalIcon,
  isSuccess = false,
}) => {
  const onClose = () => {
    setIsModalVisible(false);
    if (setIsDeleteId) {
      setIsDeleteId(null);
    }
    if (setAdditionalId) {
      setAdditionalId(null);
    }
  };
  return (
    <Modal
      title={""}
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.modalClose}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button type="button" className="btn btn-lg btn-outline-secondary min-w-130" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            disabled={isLoading}
            className={`btn btn-lg min-w-130 ${isSuccess ? "btn-success" : "btn-danger"}`}
            onClick={handleDelete}
          >
            {isLoading ? <BtnLoader /> : buttonName ? buttonName : "Delete"}
          </button>
        </div>
      }
      className="delete-modal"
    >
      <div className="modal-body page-form">
        {isLogo && <div className="d-flex justify-content-center">{iconSvg}</div>}
        <div className="fw-semibold fs-4 d-flex text-black justify-content-center mt-3 text-center">{title}</div>
        <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">{description}</p>
      </div>
    </Modal>
  );
};

export default CommonDeleteModal;
